import { primaryGreen, secondeGreen, thirdGreen } from "../utils/colors";

const Loading = ({ message = "در حال بارگذاری..." }) => {
  return (
    <div className="fixed inset-0 bg-white bg-opacity-80 flex flex-col items-center justify-center z-50 p-4">
      {/* اسپینر لودینگ با سایزهای مختلف برای دستگاه‌های متفاوت */}
      <div className="relative w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 mb-3 md:mb-4 lg:mb-6">
        {/* حلقه بیرونی */}
        <div
          className="absolute inset-0 border-[3px] md:border-4 border-t-transparent rounded-full animate-spin"
          style={{
            borderColor: thirdGreen,
            borderTopColor: "transparent",
            animationDuration: "1.8s",
          }}
        ></div>

        {/* حلقه میانی */}
        <div
          className="absolute inset-2 md:inset-[6px] lg:inset-2 border-[3px] md:border-4 border-t-transparent rounded-full animate-spin"
          style={{
            borderColor: secondeGreen,
            borderTopColor: "transparent",
            animationDuration: "1.3s",
            animationDirection: "reverse",
          }}
        ></div>

        {/* حلقه داخلی */}
        <div
          className="absolute inset-4 md:inset-[12px] lg:inset-4 border-[3px] md:border-4 border-t-transparent rounded-full animate-spin"
          style={{
            borderColor: primaryGreen,
            borderTopColor: "transparent",
            animationDuration: "0.8s",
          }}
        ></div>
      </div>

      {/* متن لودینگ با سایزهای مختلف */}
      <p
        className="text-base md:text-lg lg:text-xl font-medium text-center mb-4 md:mb-6 lg:mb-8"
        style={{ color: primaryGreen }}
      >
        {message}
      </p>

      {/* نوار پیشرفت با عرض ریسپانسیو */}
      <div className="w-48 sm:w-56 md:w-64 h-1.5 md:h-2 bg-gray-200 rounded-full overflow-hidden">
        <div
          className="h-full rounded-full animate-progress"
          style={{
            backgroundImage: `linear-gradient(to right, ${primaryGreen}, ${secondeGreen}, ${thirdGreen})`,
            animationDuration: "2s",
            animationIterationCount: "infinite",
          }}
        ></div>
      </div>

      {/* متن اختیاری برای دستگاه‌های بزرگ */}
      <p className="hidden md:block mt-4 text-sm text-gray-600">
        لطفاً چند لحظه صبر کنید...
      </p>
    </div>
  );
};

export default Loading;
